// Sidebar
export const SIDEBAR_VISIBILITY_TOGGLE = "SIDEBAR/VISIBILITY_TOGGLE";
export const SIDEBAR_VISIBILITY_SHOW = "SIDEBAR/VISIBILITY_SHOW";
export const SIDEBAR_VISIBILITY_HIDE = "SIDEBAR/VISIBILITY_HIDE";
export const SIDEBAR_STICKY_TOGGLE = "SIDEBAR/STICKY_TOGGLE";
export const SIDEBAR_STICKY_ENABLE = "SIDEBAR/STICKY_ENABLE";
export const SIDEBAR_STICKY_DISABLE = "SIDEBAR/STICKY_DISABLE";

// Layout
export const LAYOUT_BOXED_TOGGLE = "LAYOUT/BOXED_TOGGLE";
export const LAYOUT_BOXED_ENABLE = "LAYOUT/BOXED_ENABLE";
export const LAYOUT_BOXED_DISABLE = "LAYOUT/BOXED_DISABLE";

// Theme
export const THEME_TOGGLE = "THEME/TOGGLE";

//Global
export const GLOBAL_BLOCK_UI = `@GLOBAL/BLOCK`;
export const GLOBAL_RELEASE_UI = `@GLOBAL/RELEASE_UI`;

// User
export const USER_TOKEN_NAME = "mbAmerenReportAuthToken";
export const ADMIN_TOKEN_NAME = "mbAmerenReportAuthToken_ADMIN";
export const INTERNAL_TOKEN_NAME = "mbInternal";
export const USER_DESIRED_PAGE = "mbAmerenReportDesiredPage";

export const USER_LOADING = "USER/LOADING";
export const USER_AVAILABLE = "USER/AVAILABLE";
export const LOAD_USER = "USER/LOAD";
export const REGISTER_USER = "USER/REGISTER";
export const LOGIN_USER = "USER/LOGIN";
export const LOGOUT_USER = "USER/LOGOUT";
export const UPDATE_USER = "USER/UPDATE";
export const DELETE_USER = "USER/DELETE";
export const AUTH_ERROR = "AUTH/ERROR";

// Admin
export const ADMIN_LOADING = "ADMIN/LOADING";
export const STORE_USER = "ADMIN/STORE_USER";
export const SET_USERS = "ADMIN/SET_USERS";
export const SELECT_USER = "ADMIN/SELECT_USER";
export const SET_SEEDS = "ADMIN/SET_SEEDS";
export const SELECT_SEED = "ADMIN/SELECT_SEED";
export const SET_WHITELIST = "ADMIN/SET_WHITELIST";
export const SELECT_WHITELIST = "ADMIN/SELECT_WHITELIST";
export const SET_MBID_LOOKUP = "ADMIN/SET_MBID_LOOKUP";
export const SET_UNIQUEID_LOOKUP = "ADMIN/SET_UNIQUEID_LOOKUP";
export const SET_PREFERENCE_LOOKUP = "ADMIN/SET_PREFERENCE_LOOKUP";
export const SET_SPAMCHECK = "ADMIN/SET_SPAMCHECK";
export const ADMIN_ERROR = "ADMIN/ERROR";

// Reports
export const REPORT_LOADING = "REPORTS/LOADING";
export const RESET_REPORTS = "REPORTS/RESET";
export const ADD_REPORT_ERROR = "REPORTS/ADD_ERROR";

// Results
export const SET_RESULT_TYPES = "RESULTS/SET_TYPES";
export const SET_RESULT_SUBTYPES = "RESULTS/SET_SUBTYPES";
export const SET_RESULT_COUNTS = "RESULTS/SET_RESULT_COUNTS";
export const SET_RESULT_STATS = "RESULTS/SET_RESULT_STATS";

// Reports
export const BIDGELY_REPORT_LOADING = "BIDGELY/LOADING";
export const RESET_BIDGELY_REPORTS = "BIDGELY/RESET";
export const ADD_BIDGELY_REPORT_ERROR = "BIDGELY/ADD_ERROR";

// Bidgely
export const BIDGELY_CLICK_REPORT_LOADING = "BIDGELY/CLICK_LOADING";
export const BIDGELY_DEVICE_REPORT_LOADING = "BIDGELY/DEVICE_LOADING";
export const BIDGELY_PLATFORM_SUMMARY_REPORT_LOADING = "BIDGELY/PLATFORM_SUMMARY_LOADING";
export const BIDGELY_DOWNLOAD_REPORT_LOADING = "BIDGELY/DOWNLOAD_REPORT_LOADING";
export const BIDGELY_SUBTYPE_LOADING = "BIDGELEY/SUBTYPE_LOADING";
export const BIDGELY_TYPE_LOADING = "BIDGELEY/SUBTYPE_LOADING";
export const SET_BIDGELY_TYPES = "BIDGELY/SET_TYPES";
export const SET_BIDGELY_SUBTYPES = "BIDGELY/SET_SUBTYPES";
export const SET_BIDGELY_COUNTS = "BIDGELY/SET_RESULT_COUNTS";
export const SET_BIDGELY_STATS = "BIDGELY/SET_RESULT_STATS";
export const SET_BIDGELY_CLICK_TABLE = "BIDGELY/SET_CLICK_TABLE";
export const SET_BIDGELY_PLATFORMSUMMARY_TABLE = "BIDGELY/SET_PLATFORMSUMMARY_TABLE";
export const SET_BIDGELY_DEVICE = "BIDGELY/SET_BIDGELY_DEVICE";
export const BIDGELY_REPORT_DOWNLOADED = "BIDGELY/SET_BIDGELY_REPORTDOWNLOADED";

// Mobile Originated
export const MOBILE_ORIGINATED_LOADING = "MOBILE_ORIGINATED/LOADING";
export const SET_MO_COUNTS = "MOBILE_ORIGINATED/SET_COUNTS";
export const ADD_MOBILE_ORIGINATED_ERROR = "MOBILE_ORIGINATED/ERROR";

// Up Sell
export const UP_SELL_LOADING = "UP_SELL/LOADING";
export const SET_UP_SELL_TYPES = "UP_SELL/SET_TYPES";
export const SET_UP_SELL_SUBTYPES = "UP_SELL/SET_SUBTYPES";
export const SET_UP_SELL_COUNTS = "UP_SELL/SET_COUNTS";
export const ADD_UP_SELL_ERROR = "UP_SELL/ERROR";

// MultiFactor
export const MFA_LOADING = "MFA/LOADING";
export const SET_MFA_COUNTS = "MFA/SET_COUNTS";
export const SET_MFA_STATS = "MFA/SET_STATS";
export const ADD_MFA_ERROR = "MFA/ERROR";

//CAMPAIGN
export const CAMPAIGN_ERROR = "CAMPAIGN/ERROR";
export const CAMPAIGN_LOADING = "CAMPAIGN/LOADING";
export const CAMPAIGN_DATABASE_UPDATING = "CAMPAIGN/SAVING";
export const SET_CAMPAIGNS = "CAMPAIGN/SET";
export const CAMPAIGN_DATABASE_UPDATE = "CAMPAIGN/UPDATE";
export const CAMPAIGN_DATABASE_UPDATE_ERROR = "CAMPAIGN/UPDATE_ERROR";

// TEMPLATES
export const TEMPLATE_LOADING = "TEMPLATES/LOADING";
export const TEMPLATE_ERROR = "TEMPLATES/ERROR";
export const SET_TEMPLATES = "TEMPLATES/SET";
export const SET_ON_DEMAND_TEMPLATES = "TEMPLATES/SET";
export const SELECT_TEMPLATE = "TEMPLATES/SELECT";

export const GET_EDITOR_INFORMATION = "GET_EDITOR_INFORMATION";
export const GET_EDITOR_INFORMATION_ERROR = "GET_EDITOR_INFORMATION_ERROR";
export const GET_EDITOR_INFORMATION_LOADING = "GET_EDITOR_INFORMATION_LOADING";

export const EDITOR_DATABASE_UPDATE = "EDITOR_DATABASE_UPDATE";
export const EDITOR_DATABASE_UPDATE_ERROR = "EDITOR_DATABASE_UPDATE_ERROR";

export const GET_TEMPLATE_HISTORY = "GET_TEMPLATE_HISTORY";
export const GET_TEMPLATE_HISTORY_ERROR = "GET_TEMPLATE_HISTORY_ERROR";
export const GET_TEMPLATE_HISTORY_LOADING = "GET_TEMPLATE_HISTORY_LOADING";

export const GET_CURRENT_TEMPLATE_FOR_APPROVAL_LOADING =
  "GET_CURRENT_TEMPLATE_FOR_APPROVAL_LOADING";
export const GET_CURRENT_TEMPLATE_FOR_APPROVAL_INFO = "GET_CURRENT_TEMPLATE_FOR_APPROVAL_INFO";
export const GET_CURRENT_TEMPLATE_FOR_APPROVAL_ERROR = "GET_CURRENT_TEMPLATE_FOR_APPROVAL_ERROR";

export const GET_DRAFT_TEMPLATE_FOR_APPROVAL_INFO = "GET_DRAFT_TEMPLATE_FOR_APPROVAL_INFO";
export const GET_DRAFT_TEMPLATE_FOR_APPROVAL_LOADING = "GET_DRAFT_TEMPLATE_FOR_APPROVAL_LOADING";
export const GET_DRAFT_TEMPLATE_FOR_APPROVAL_ERROR = "GET_DRAFT_TEMPLATE_FOR_APPROVAL_ERROR";

export const APPROVAL_DRAFT = "APPROVAL_DRAFT";
export const APPROVAL_DRAFT_ERROR = "APPROVAL_DRAFT_ERROR";

export const GET_COMMENTS_APPROVAL_INFO = "GET_COMMENTS_APPROVAL_INFO";
export const GET_COMMENTS_APPROVAL_LOADING = "GET_COMMENTS_APPROVAL_LOADING";
export const GET_COMMENTS_APPROVAL_ERROR = "GET_COMMENTS_APPROVAL_ERROR";

export const SET_SELECTED_OPTIONS = "SET_SELECTED_OPTIONS";

//ecs sync
export const GET_SMS_TEMPLATE_LOADING = "GET_SMS_TEMPLATE_LOADING";
export const GET_SMS_TEMPLATE_ERROR = "GET_SMS_TEMPLATE_ERROR";
export const GET_SMS_TEMPLATE_INFO = "GET_SMS_TEMPLATE_INFO";

export const GET_EMAIL_TEMPLATE_LOADING = "GET_EMAIL_TEMPLATE_LOADING";
export const GET_EMAIL_TEMPLATE_ERROR = "GET_EMAIL_TEMPLATE_ERROR";
export const GET_EMAILTEMPLATE_INFO = "GET_EMAIL_TEMPLATE_INFO";

export const ENABLE_ECS_LOADING = "ENABLE_ECS_LOADING";
export const ENABLE_ECS_INFO = "ENABLE_ECS_INFO";
export const ENABLE_ECS_ERROR = "ENABLE_ECS_ERROR";

// Credit Transfer
export const CREDIT_TRANSFER_REPORT_LOADING = "CREDITTRANSFER/REPORT_LOADING";
export const SET_CREDIT_TRANSFER_TYPES = "CREDIT_TRANSFER/SET_TYPES";
export const SET_CREDIT_TRANSFER_SUBTYPES = "CREDIT_TRANSFER/SET_SUBTYPES";
export const SET_CREDIT_TRANSFER_STATS = "CREDIT_TRANSFER/SET_RESULT_COUNTS";
export const CREDIT_TRANSFER_REPORT_DOWNLOADED = "CREDIT_TRANSFER/SET_REPORTDOWNLOADED";
export const RESET_CREDIT_TRANSFER_REPORTS = "CREDIT_TRANSFER/RESET";
export const ADD_CREDIT_TRANSFER_REPORT_ERROR = "CREDIT_TRANSFER/ADD_ERROR";

export const CAMPAIGN_ONOFF_ERROR = "CAMPAIGN_ONOFF/ERROR";
export const CAMPAIGN_ONOFF_LOADING = "CAMPAIGN_ONOFF/LOADING";
export const CAMPAIGN_ONOFF_DATABASE_UPDATING = "CAMPAIGN_ONOFF/SAVING";
export const SET_CAMPAIGNS_ONOFF = "CAMPAIGN_ONOFF/SET";
export const CAMPAIGN_ONOFF_DATABASE_UPDATE = "CAMPAIGN_ONOFF/UPDATE";
export const CAMPAIGN_ONOFF_DATABASE_UPDATE_ERROR = "CAMPAIGN_ONOFF/UPDATE_ERROR";
